//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Routing.js";
import "../no/Builder.js";
import "../no/SelectNXObject.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[1,"PortSelection",0,"SelectNXObject",0],[1,"RotationAngle",0,"Expression",0]],[[[],"StartDrag",{},0,0],[["translation","rotation"],"DragByTransform",{},2,0],[[],"StopDrag",{},0,0],[["portTag","suppress"],"SuppressPortConstraint",{},2,0],[["angle"],"UpdateRotationAngle",{},1,0],[["port"],"InitializeFromPort",{},1,0],[["lockRotation"],"SetLockRotation",{},1,0],[["lockEngagement"],"SetLockEngagement",{},1,0]],[]];
SPLM.Routing.ClockPartBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Routing.ClockPartBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;